import { FC, PropsWithChildren } from 'react'
import { useOktaAuth } from '@okta/okta-react'

import AppLayoutBase from '@aws-northstar/ui/components/AppLayout'
const AppLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
	const { authState, oktaAuth } = useOktaAuth()
	const email = authState?.idToken?.claims.email as string
	const username = authState?.idToken?.claims.name as string
	const isSignedOut = !authState || !authState.isAuthenticated

	const signout = async (): Promise<void> => {
		await oktaAuth.signOut()
	}

	return (
		<AppLayoutBase
			title="Self Service Portal"
			toolsHide
			navigationItems={[
				{
					type: 'link',
					text: `Dashboard`,
					href: '/dashboard'
				},
				{ type: 'divider' },
				{
					type: 'section-group',
					title: 'Cloud Service Providers (CSPs)',
					items: [
						{
							type: 'section',
							text: 'AWS',
							items: [
								{
									type: 'link',
									text: 'Accounts',
									href: '/accounts'
								},
								{
									type: 'link',
									text: 'Clusters',
									href: '/clusters'
								},
								{
									type: 'expandable-link-group',
									text: 'Projects',
									href: '/projects',
									items: [
										{
											type: 'link',
											text: 'SSL Certificates',
											href: '/projects/resources/sslCerts'
										}
									]
								},
							]
						},
						{
							type: 'section',
							text: 'GCP',
							items: [
								{
									type: 'link',
									text: 'Projects',
									href: '/gcpProjects'
								},
								{
									type: 'link',
									text: 'Clusters',
									href: '/cluster'
								},
								{
									type: 'expandable-link-group',
									text: 'Applications',
									href: '/applications',
									items: [
										{
											type: 'link',
											text: 'GCP Certificates',
											href: '/gcpCerts'
										}
									]
								},
								{
									type: 'link',
									text: 'Microservices',
									href: '/microservices'
								},
								{
									type: 'link',
									text: 'APIs',
									href: '/apis'
								},
								{
									type: 'section',
									text: 'RHOCP',
									items: [
										{
											type: 'link',
											text: 'Tenants',
											href: '/rhocpTenants'
										}
									]
								}
							]
						},
					]
				},
				{ type: 'divider' },
				{
					type: 'section-group',
					title: 'Administration',
					items: [
						{
							type: 'link',
							text: 'Access Management',
							href: '/access-management'
						},
						{
							type: 'link',
							text: 'Active Directory',
							href: '/active-directory'
						}
					]
				}
			]}
			user={{
				email,
				username
			}}
			onSignout={signout}
			breadcrumbGroupHide
			navigationHide={isSignedOut}
		>
			{children}
		</AppLayoutBase>
	)
}

export default AppLayout
